import { Component } from '@theme/component';

/**
 * Pauses the autoplaying hero video for visitors who asked their system for
 * reduced motion. There is deliberately no visible control: the owner wants the
 * hero to stay clean, so this runs silently.
 */
class HeroVideo extends Component {
  requiredRefs = ['video'];

  connectedCallback() {
    super.connectedCallback();

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.reducedMotion.addEventListener('change', this.onMotionPreferenceChange);

    if (this.reducedMotion.matches) {
      this.refs.video.pause();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.reducedMotion?.removeEventListener('change', this.onMotionPreferenceChange);
  }

  onMotionPreferenceChange = (event) => {
    if (event.matches) {
      this.refs.video.pause();
    } else {
      this.refs.video.play?.().catch(() => {
        /* autoplay may be refused; nothing to recover */
      });
    }
  };
}

if (!customElements.get('hero-video')) {
  customElements.define('hero-video', HeroVideo);
}
